var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "panel-group", attrs: { gutter: 20 } },
    [
      _c("el-col", { staticClass: "card-panel-col", attrs: { span: 7 } }, [
        _c("div", { staticClass: "card-panel" }, [
          _c(
            "div",
            { staticClass: "card-panel-text" },
            [
              _vm._v(" " + _vm._s(_vm.$t("dashboard.balance")) + " "),
              !_vm.checkPermission(["ROLE_AUTH_AGENT_ADMIN"])
                ? _c("el-tooltip", { attrs: { placement: "top" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: { width: "300px" },
                        attrs: { slot: "content" },
                        slot: "content",
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("tips.dashboard_balance_question"))
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "span",
                      [
                        _c("svg-icon", {
                          staticClass: "icon-question",
                          attrs: { "icon-class": "icon-font-question" },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "card-panel-num" },
            [
              _vm._v(
                _vm._s(_vm.$store.getters.currency) +
                  " " +
                  _vm._s(
                    _vm._f("toDivideWithDot")(_vm.overviewData.total_balance)
                  ) +
                  " "
              ),
              _c("el-tooltip", { attrs: { placement: "bottom" } }, [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("tips.dashboard_balance_number")) +
                        " " +
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            _vm.overviewData.available_withdraw
                          )
                        )
                    ),
                  ]),
                ]),
                _c(
                  "span",
                  [
                    _c("svg-icon", {
                      staticClass: "icon-warning",
                      attrs: { "icon-class": "icon-font-warning" },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("el-col", { staticClass: "card-panel-col ", attrs: { span: 7 } }, [
        _c("div", { staticClass: "card-panel" }, [
          _c("div", { staticClass: "card-panel-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("dashboard.in_transit")) + " "),
          ]),
          _c("div", { staticClass: "card-panel-num" }, [
            _vm._v(
              _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(_vm._f("toDivideWithDot")(_vm.overviewData.in_transit))
            ),
          ]),
          _c("img", {
            staticClass: "img-bg",
            attrs: { src: require("@/assets/ezpay/bg_transfer.png") },
          }),
        ]),
      ]),
      _vm.overviewData.adb_amount
        ? _c("el-col", { staticClass: "card-panel-col ", attrs: { span: 7 } }, [
            _c("div", { staticClass: "card-panel" }, [
              _c("div", { staticClass: "card-panel-text" }, [
                _vm._v(" " + _vm._s(_vm.$t("dashboard.abd_balance")) + " "),
              ]),
              _c("div", { staticClass: "card-panel-num" }, [
                _vm._v(
                  _vm._s(_vm._f("toDivideWithDot")(_vm.overviewData.adb_amount))
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }